import { render, staticRenderFns } from "./MerchantBasicInfo.vue?vue&type=template&id=383f9a53&scoped=true"
import script from "./MerchantBasicInfo.vue?vue&type=script&lang=js"
export * from "./MerchantBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./MerchantBasicInfo.vue?vue&type=style&index=0&id=383f9a53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f9a53",
  null
  
)

export default component.exports